export const SITE_NAME = 'CashStat'
export const SHORT_NAME = 'CashStat'

export const MAIN_URL = ''
export const FRONTEND_URL = window.location.hostname === 'localhost'? 'http://localhost:3000':'https://cashstat.netlify.app'
export const BACKEND_URL = window.location.hostname === 'localhost'? 'http://localhost:5000':'https://cashstat-febadce5d44a.herokuapp.com'

export const STORAGE_KEY_USER_PROFILE = 'CS-token'
export const STORAGE_KEY_BUDGET_ACCOUNTS = 'CS-accounts'
export const STORAGE_KEY_BUDGET_TAGS = 'CS-tags'
export const STORAGE_KEY_BUDGET_CATEGORIES = 'CS-categories'
export const STORAGE_KEY_BUDGET_ITEMS = 'CS-items'
export const STORAGE_KEY_BUDGET_TRANSACTIONS = 'CS-transactions'